import { render, staticRenderFns } from "./zc-unit.vue?vue&type=template&id=2c047bbb"
import script from "./zc-unit.vue?vue&type=script&lang=js"
export * from "./zc-unit.vue?vue&type=script&lang=js"
import style0 from "./zc-unit.vue?vue&type=style&index=0&id=2c047bbb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports